
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dcs",
      function () {
        return require("private-next-pages/dcs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dcs"])
      });
    }
  